import { render, staticRenderFns } from "./RidesServiceFilter.vue?vue&type=template&id=5982f3f7&scoped=true"
import script from "./RidesServiceFilter.vue?vue&type=script&lang=js"
export * from "./RidesServiceFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5982f3f7",
  null
  
)

export default component.exports